export const defaultDebugAllSelector = (state) =>
  state?.defaultDebugReducer?.defaultDebugAll;
export const defaultDebugOpenAddSelector = (state) =>
  state?.defaultDebugReducer?.defaultDebugOpenAdd;
export const defaultDebugOpenEditSelector = (state) =>
  state?.defaultDebugReducer?.defaultDebugOpenEdit;
export const defaultDebugSelectedSelector = (state) =>
  state?.defaultDebugReducer?.defaultDebugSelected;
export const defaultDebugSearchSelector = (state) =>
  state?.defaultDebugReducer?.defaultDebugSearch;
